var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Basic"},[_c('main'),_c('Footer',{attrs:{"footer-left":_vm.footerLeft,"footer-right":_vm.footerRight,"legal-page":_vm.legalPage,"legal-page-label":_vm.legalPageLabel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }